import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
const router = new Router({
  mode: "hash",
  // scrollBehavior(to, from, savedPosition) {
  //   return {
  //     x: 0,
  //     y: 0
  //   }
  // },
  routes: [
    {
      path: "/loginjump",
      name: "loginjump",
      component: resolve => require(['@/components/loginjump'], resolve)
    },
    {
      path: "/indexjump",
      name: "indexjump",
      component: resolve => require(['@/components/indexjump'], resolve)
    },
    {
      path: "/",
      name: "index",
      component: resolve => require(['@/components/index'], resolve)
    },//首页
    // {
    //   path: "/test",
    //   name: "test",
    //   component:resolve => require(['@/components/test/test'], resolve)
    // },
    // {
    //   path: "/test1",
    //   name: "test1",
    //   component:resolve => require(['@/components/test/test1'], resolve)
    // },
    {
      path: '/personal',
      name: 'personal',
      component: resolve => require(['@/components/personal/personal'], resolve)
    },//重置密码
    {
      path: '/navigation',
      name: 'navigation',
      component: resolve => require(['@/components/index/navigation/navigation'], resolve)
    },//办事导航
    {
      path: '/supermarket',
      name: 'supermarket',
      component: resolve => require(['@/components/index/supermarket/supermarket'], resolve)
    },//金融机构
    {
      path: '/shenpi',
      name: 'shenpi',
      component: resolve => require(['@/components/index/shenpi/shenpi'], resolve)
    },//在线审批
    {
      path: '/shenpi/shenpidetail',
      name: 'shenpidetail',
      component: resolve => require(['@/components/index/shenpi/shenpidetail'], resolve)
    },//在线审批
    {
      path: "/indexserch",
      name: "indexserch",
      component: () => import('@/components/index/indexserch/indexserch')
    }, //首页搜索页面
    {
      path: "/recommended",
      name: "recommended",
      component: () => import('@/components/index/recommended/recommended')
    }, //重点推荐
    {
      path: "/policy/policydetali",
      name: "noticedatali",
      component: () => import('@/components/index/policy/policydetali')
    }, //公告详情
    {
      path: "/policy",
      name: "policy",
      component: () => import('@/components/index/policy/policy')
    }, //公告
    {
      path: "/information",
      name: "information",
      component: () => import('@/components/index/information/information')
    },//政策信息
	{
	  path: "/cashcurrencyindex",
	  name: "cashcurrencyindex",
	  component: () => import('@/components/cashcurrencyweb/cashcurrencyindex')
	},//兑现通
    {
      //政策信息列表
      path: "/informationMore",
      name: "informationMore",
      component: () => import('@/components/index/information/informationMore')
    },
    {
      path: "/information/informationMore/informationdetali",
      name: "informationdetali",
      component: () => import('@/components/index/information/informationdetali')
    }, //政策信息详情
    {
      path: "/openly",
      name: "openly",
      component: () => import('@/components/index/openly/openly')
    },//政务公开
    {
      path: "/information/guides",
      name: "guides",
      component: () => import('@/components/index/information/guides')
    },  //办事指南
    {//经办人在线诉求详情
      path: '/Antonym/Operator/list/listdetail',
      name: 'listdetail',
      component: () => import('@/components/index/Antonym/listdetail'),
    },
    {
      path: "/information/guides/guidesDetali",
      name: "guidesDetali",
      component: () => import('@/components/index/information/guidesDetali')
    }, //办事指南详情
    {
      path: "/Antonym",
      name: "Antonym",
      redirect: '/Antonym/faren',
      component: () => import('@/components/index/Antonym/Antonym'),
      children: [
        {
          path: '/Antonym/faren',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'farens',
          component: () => import('@/components/index/Antonym/faren')
        },
        {
          path: '/Antonym/Operator',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'Operator',
          redirect: '/Antonym/Operator/list',
          component: () => import('@/components/index/Antonym/Operator'),
          children: [
            {//经办人在线诉求列表
              path: '/Antonym/Operator/list',
              name: 'list',
              component: () => import('@/components/index/Antonym/list'),
            },
            {//在线诉求统计
              path: '/Antonym/Operator/tableMysuqiu',
              component: () => import('@/components/index/Antonym/tableEc/table-mysuqiu'),
            },
            {//我的办理企业
              path: '/Antonym/Operator/tableMq',
              name: 'tableMq',
              component: () => import('@/components/index/Antonym/tableEc/table-mq'),
            },
          ]
        },
        {//领导人登录页面
          path: '/Antonym/Leadership',
          name: 'Leadership',
          redirect: '/Antonym/Leadership/sulist',
          component: () => import('@/components/index/Antonym/Leadership'),
          children: [//统计报表
            {//在线诉求统计
              path: '/Antonym/Leadership/tableMysuqiu',
              component: () => import('@/components/index/Antonym/tableEc/table-mysuqiu'),
            },
            {//诉求办理统计
              path: '/Antonym/Leadership/tableSqbl',
              name: 'tableSqbl',
              meta: {keepAlive: true},// 缓存
              component: () => import('@/components/index/Antonym/tableEc/table-sqbl'),
            },
            {//所有在线诉求
              path: '/Antonym/Leadership/sulist',
              name: 'sulist',
              component: () => import('@/components/index/Antonym/sulist'),
            },
            {
              path: '/Antonym/Leadership/order',
              name: 'orders',
              component: () => import('@/components/personal/menu/zhengfu/order'),
            },//诉求审核
          ]
        }
      ]
    },//在线诉求
    {
      path: "/Corporation",
      name: "Corporation",
      component: () => import('@/components/index/Corporation/Corporation')
    }, //民企风采
    {
      path: "/Corporation/Corporationlist",
      name: "Corporationlist",
      component: () => import('@/components/index/Corporation/Corporationlist')
    }, //企业列表
    {
      path: "/Antonym/Antonymdetali",
      name: "Antonymdetali",
      component: () => import('@/components/index/Antonym/Antonymdetali')
    },
    //企业名录风采
    {
      path: "/Corporation/CorporationML",
      name: "CorporationML",
      component: () => import('@/components/index/Corporation/CorporationML')
    },
    //在线诉求信息详情
    {
      path: "/Corporation/myspace",
      name: "myspace",
      component: () => import('@/components/index/Corporation/myspace')
    },//企业微空间
    {
      path: "/chaoshi",
      name: "chaoshi",
      component: () => import('@/components/index/supermarket/chaoshi')
    },//金融超市
    {
      path: "/services",
      name: "services",
      component: () => import('@/components/index/supermarket/services')
    },//涉企服务
    {
      path: "/supermarketint",
      name: "supermarketint",
      component: () => import('@/components/index/supermarket/supermarketint')
    },//金融超市详情页
    {
      path: "/servicesint",
      name: "servicesint",
      component: () => import('@/components/index/supermarket/servicesint')
    },//涉企服务详情页
    {
      path: "/listdetail",
      name: "listdetails",
      component: () => import('@/components/index/supermarket/listdetail')
    },//金融超市详情页
    {
      path: "/sisone",
      name: "sisone",
      component: () => import('@/components/index/sisone/sisone')
    },//四送一服
    {
      path: "/sisone/int",
      name: "sisoneint",
      component: () => import('@/components/index/sisone/sisint')
    },//四送一服详情
    {
      path: "/tellme",
      name: "tellme",
      component: () => import('@/components/index/tellme/tellme')
    },//关于我们
    {
      path: "/telhelp",
      name: "telhelp",
      redirect: '/telhelp/work',
      component: () => import('@/components/index/telhelp/telhelp'),
      children: [
        {
          path: 'work',
          name: 'work',
          component: () => import('@/components/index/telhelp/work')
        },//工作动态
        {
          path: 'questrion',
          name: 'questrion',
          component: () => import('@/components/index/telhelp/questrion')
        }, {
          path: 'mywork',
          name: 'mywork',
          component: () => import('@/components/index/telhelp/mywork')
        }, {
          path: 'detail',
          name: 'detail',
          component: () => import('@/components/index/telhelp/detail')
        },
        {
          path: 'addtell',
          name: 'addtell',
          component: () => import('@/components/index/telhelp/addtell')
        }
      ]
    },//联系帮扶
    {
      path: "/telhelpdetail",
      name: "telhelpdetail",
      component: () => import('@/components/index/telhelp/telhelpdetail')
    },//联系帮扶详情
    {
      path: "/personal",
      name: "personal",
      component: resolve => require(['@/components/personal/personal'], resolve),
      children: [
        {
          path: 'faren',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'faren',
          component: () => import('@/components/mineCenter/personr/shenren')
        },//身份认证
        {
          path: 'stylesheet',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'stylesheet',
          component: () => import('@/components/mineCenter/market/minqi')
        },//民企风采维护
        {
          path: 'myshenpi',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'myshenpi',
          component: () => import('@/components/mineCenter/shenpi/shenpi')
        },//审批列表
        {
          path: 'myshenpint',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'myshenpiint',
          component: () => import('@/components/mineCenter/shenpi/myshenpiint')
        },//审批列表详情
        {
          path: 'resultshenpi',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'resultshenpi',
          component: () => import('@/components/mineCenter/shenpi/resultshenpi')
        },//审批列表详情
        {
          path: 'supplypublic',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'supplypublic',
          component: () => import('@/components/mineCenter/supplypublic/supplypublic'),
        },//供需发布
        {
          path: 'addsupplypublic',
          name: 'addsupplypublic',
          component: () => import('@/components/mineCenter/supplypublic/addsupplypublic'),
        },//供需发布添加
        {
          path: 'administration',
          name: 'administration',
          component: () => import('@/components/mineCenter/administration/administration'),
        },
        //云服务商品
        {
          path: 'cloudsGoods',
          name: 'cloudsGoods',
          component: () => import('@/components/mineCenter/crm_claim/cloudsGoods'),
        },
        //云服务商品分类列表
        {
          path: 'cloudsGlist',
          name: 'cloudsGlist',
          component: () => import('@/components/mineCenter/crm_claim/cloudsGlist'),
        },
        //云服务订单
        {
          path: 'cloudsOrders',
          name: 'cloudsOrders',
          component: () => import('@/components/mineCenter/crm_claim/cloudsOrders'),
        },
        // //云服务订单列表
        {
          path: 'cloudsOlist',
          name: 'cloudsOlist',
          component: () => import('@/components/mineCenter/crm_claim/cloudsOlist'),
        },
        {
          path: 'ReCompang',
          name: 'ReCompang',
          component: () => import('@/components/mineCenter/crm_claim/ReCompang'),
        },
        {
          path: 'ReCompangList',
          name: 'ReCompangList',
          component: () => import('@/components/mineCenter/crm_claim/ReCompangList'),
        },
        //产品管理
        {
          path: 'addadministration',
          name: 'addadministration',
          component: () => import('@/components/mineCenter/administration/administration'),
        },//产品管理添加
        {
          path: 'setpassword',
          name: 'setpassword',
          component: () => import('@/components/mineCenter/setpassword/setpassword'),
        },//修改密码
        {
          path: 'news',
          name: 'news',
          component: () => import('@/components/mineCenter/news/news'),
        },//系统消息
        {
          path: 'shoucang',
          name: 'shoucang',
          component: () => import('@/components/mineCenter/shoucang/shoucang'),
        },//收藏
        {
          path: 'onlinesuqiu',
          name: 'onlinesuqiu',
          component: () => import('@/components/mineCenter/onlinesuqiu/onlinesuqiu'),
        },//在线诉求
        {
          path: 'queryonlinesuqiu',
          name: 'queryonlinesuqiu',
          component: () => import('@/components/mineCenter/onlinesuqiu/queryonlinesuqiu'),
        },//在线诉求查看
        {
          path: 'importanttuijian',
          name: 'importanttuijian',
          component: () => import('@/components/mineCenter/importanttuijian/importanttuijian'),
        },//重点推荐
        // {
        //   path: 'handleenterprise',
        //   name: 'handleenterprise',
        //   component: () => import('@/components/mineCenter/handleenterprise/handleenterprise'),
        // },//办理企业
        {
          path: 'friend',
          name: 'friend',
          component: () => import('@/components/mineCenter/friend/friend'),
        },//朋友圈
        {
          path: 'enterprisezizhi',
          name: 'enterprisezizhi',
          component: () => import('@/components/mineCenter/enterprisezizhi/enterprisezizhi'),
        },//企业资质
        {
          path: 'jingyang',
          name: 'jingyang',
          component: () => import('@/components/mineCenter/jingyan/jingyang'),
        },//经验推荐列表
        {//网站内容
          path: 'tableWznr',
          name: 'tableWznr',
          component: () => import('@/components/index/Antonym/tableEc/table-wznr'),
        },
        {//政策发布效果统计
          path: 'tableFa',
          name: 'tableFa',
          component: () => import('@/components/index/Antonym/tableEc/table-fa'),
        },
        {//企业建档统计
          path: 'tableJd',
          name: 'tableJd',
          component: () => import('@/components/index/Antonym/tableEc/table-jd'),
        },
        {//评分统计
          path: 'stars',
          name: 'stars',
          component: () => import('@/components/index/Antonym/tableEc/stars'),
        },
        {//企业活跃统计
          path: 'tableQyhy',
          name: 'tableQyhy',
          component: () => import('@/components/index/Antonym/tableEc/table-qyhy'),
        },
        {//注册资金统计
          path: 'zijin',
          name: 'zijin',
          component: () => import('@/components/index/Antonym/tableEc/zijin'),
        },
        {//发送短信
          path: 'sendmsg',
          name: 'sendmsg',
          component: () => import('@/components/mineCenter/sendmsg/sendmsg'),
        },
        {//短信发送记录 message
          path: 'message',
          name: 'message',
          component: () => import('@/components/mineCenter/sendmsg/message'),
        },
        {//金融超市栏目
          path: 'column',
          name: 'column',
          component: () => import('@/components/mineCenter/market/column'),
        },
        {//部门发布通知公告
          path: 'addnotices',
          name: 'addnotices',
          component: () => import('@/components/mineCenter/addnotices/addnotices'),
        },
        {//部门发布通知公告列表
          path: 'noticelist',
          name: 'noticelist',
          component: () => import('@/components/mineCenter/addnotices/noticelist'),
        },
        {//文件列表
          path: 'filelist',
          name: 'filelist',
          component: () => import('@/components/mineCenter/addnotices/filelist'),
        },
        {
          path: 'orderDiqu',
          name: 'orderDiqu',
          component: () => import('@/components/mineCenter/crm_claim/orderDiqu'),
        },//工单分地区统计
        {
          path: 'orderDepartname',
          name: 'orderDepartname',
          component: () => import('@/components/mineCenter/crm_claim/order-departname'),
        },//工单按部门统计
        {
          path: 'companyOrder',
          name: 'companyOrder',
          component: () => import('@/components/mineCenter/crm_claim/companyOrder'),
        },//企业工单查询
        {
          path: 'orderDay',
          name: 'orderDay',
          component: () => import('@/components/mineCenter/crm_claim/orderDay'),
        },//工单处理日统计
        {
          path: 'orderWarring',
          name: 'orderWarring',
          component: () => import('@/components/mineCenter/crm_claim/orderWarring'),
        },//工单完成预
        {
          path: 'orderList',
          name: 'orderList',
          component: () => import('@/components/mineCenter/crm_claim/orderList'),
        },//工单列表
        {
          path: 'gongxutable',
          name: 'gongxutable',
          component: () => import('@/components/index/Antonym/tableEc/gongxutable'),
        },//供应统计
        {//在线诉求统计
          path: 'tableMysuqiu',
          name: 'tableMysuqiu',
          component: () => import('@/components/index/Antonym/tableEc/table-mysuqiu'),
        },
        {//诉求办理统计
          path: 'tableSqbl',
          name: 'tableSqbl',
          component: () => import('@/components/index/Antonym/tableEc/table-sqbl'),
        },
        {
          path: 'gongtblist',
          name: 'gongtblist',
          component: () => import('@/components/mineCenter/crm_claim/gongTblist'),
        },
        {
          path: 'seconddepartname',
          name: 'seconddepartname',
          component: () => import('@/components/mineCenter/crm_claim/second-departname'),
        },
        //诉求办理分类统计
        {
          path: 'Classification',
          name: 'Classification',
          component: () => import('@/components/mineCenter/crm_claim/Classification'),
        },
        /*云服务订单类型*/
        {
          path: 'cloudserviceordertype',
          name: 'cloudserviceordertype',
          component: () => import('@/components/mineCenter/crm_claim/cloudserviceordertype'),
        },
        /*云服务商品类型*/
        {
          path: 'productsType',
          name: 'productsType',
          component: () => import('@/components/mineCenter/crm_claim/productsType'),
        },
        /*企业建档统计 Enterprise filing*/
        {
          path: 'Enterprisefiling',
          name: 'Enterprisefiling',
          component: () => import('@/components/mineCenter/crm_claim/Enterprisefiling'),
        },
        /*企业注册统计*/
        {
          path: 'Enterpriseregistration',
          name: 'Enterpriseregistration',
          component: () => import('@/components/mineCenter/crm_claim/Enterpriseregistration'),
        },
        /*部门注册统计*/
        {
          path: 'Departmentregistration',
          name: 'Departmentregistration',
          component: () => import('@/components/mineCenter/crm_claim/Departmentregistration'),
        },
        /*部门注册统计详细*/
        {
          path: 'EnterpriseregistrationList',
          name: 'EnterpriseregistrationList',
          component: () => import('@/components/mineCenter/crm_claim/EnterpriseregistrationList'),
        },
        /*企业列表*/
        {
          path: 'enterprisesList',
          name: 'enterprisesList',
          component: () => import('@/components/mineCenter/crm_claim/enterprisesList'),
        },
        {// 企业注册列表
          path: 'registrationList',
          name: 'registrationList',
          component: () => import('@/components/mineCenter/crm_claim/registrationList'),
        },
        /*我的帮扶企业*/
        {
          path: 'Myhelping',
          name: 'Myhelping',
          component: () => import('@/components/mineCenter/crm_claim/Myhelping'),
        },
        {/*我的帮扶企业详情*/
          path: 'myhelpcompany',
          name: 'myhelpcompany',
          component: () => import('@/components/mineCenter/crm_claim/myhelpcompany'),
        },
        /*规模企业分类统计*/
        {
          path: 'Classifiedstatistics',
          name: 'Classifiedstatistics',
          component: () => import('@/components/mineCenter/crm_claim/Classifiedstatistics'),
        },
        {
          path: 'Classifiedstatisticsa',
          name: 'Classifiedstatisticsa',
          component: () => import('@/components/mineCenter/crm_claim/Classifiedstatisticsa'),
        },
        /*企业活跃统计*/
        {
          path: 'Enterpriseactivity',
          name: 'Enterpriseactivity',
          component: () => import('@/components/mineCenter/crm_claim/Enterpriseactivity'),
        },
		/*兑现通统计监测合集----start----*/
        {
          path: 'policyPublish',
          name: 'policyPublish',
          component: () => import('@/components/personal/monitor/policyPublish'),
        },
        {
          path: 'readClassification',
          name: 'readClassification',
          component: () => import('@/components/personal/monitor/readClassification'),
        },
        {
          path: 'policyDistribution',
            name: 'policyDistribution',
          component: () => import('@/components/personal/monitor/policyDistribution'),
        },
        {
          path: 'policyImpleAttribute',
          name: 'policyImpleAttribute',
          component: () => import('@/components/personal/monitor/policyImpleAttribute'),
        },
        {
          path: 'policyImpleIndustry',
            name: 'policyImpleIndustry',
          component: () => import('@/components/personal/monitor/policyImpleIndustry'),
        },
        {
          path: 'cashingResultCompany',
          name: 'cashingResultCompany',
          component: () => import('@/components/personal/monitor/cashingResultCompany'),
        },
        {
          path: 'cashingResultDeptyear',
          name: 'cashingResultDeptyear',
          component: () => import('@/components/personal/monitor/cashingResultDeptyear'),
        },
        {
          path: 'cashingResultDept',
          name: 'cashingResultDept',
          component: () => import('@/components/personal/monitor/cashingResultDept'),
        },
        /*兑现通统计监测合集----end----*/
        /*企业政策申请统计*/
        {
          path: 'Enterprisepolicy',
          name: 'Enterprisepolicy',
          component: () => import('@/components/mineCenter/crm_claim/Enterprisepolicy'),
        },
        /*政策文件发布效果*/
        {
          path: 'Policydocument',
          name: 'Policydocument',
          component: () => import('@/components/mineCenter/crm_claim/Policydocument'),
        },
        /*政务导航发布效果*/
        {
          path: 'Releaseeffect',
          name: 'Releaseeffect',
          component: () => import('@/components/mineCenter/crm_claim/Releaseeffect'),
        },
        /*新闻资讯发布效果*/
        {
          path: 'Newsandinformation',
          name: 'Newsandinformation',
          component: () => import('@/components/mineCenter/crm_claim/Newsandinformation'),
        },
        /*微视空间发布效果*/
        {
          path: 'Releaseeffecta',
          name: 'Releaseeffecta',
          component: () => import('@/components/mineCenter/crm_claim/Releaseeffecta'),
        },
        /*新闻资讯发布内容统计*/
        {
          path: 'Newsandinformationa',
          name: 'Newsandinformationa',
          component: () => import('@/components/mineCenter/crm_claim/Newsandinformationa'),
        },

        //后台移动页面
        //日常管理
        {
          path: 'myExperience',
          name: 'myExperience',
          component: () => import('@/components/personal/menu/richang/myApprovalOrderList'),
        },//我的在线审批
        {
          path: 'myExperience',
          name: 'myExperience',
          component: () => import('@/components/personal/menu/richang/myExperience'),
        },//我的经验推荐
        {
          path: 'goodsOrder',
          name: 'goodsOrder',
          component: () => import('@/components/personal/menu/goodsOrder/goodsOrder'),
        },//我的云产品订单
        {
          path: 'serviceorder',
          name: 'serviceorder',
          component: () => import('@/components/personal/menu/goodsOrder/serviceorder'),
        },//服务单位看的订单列表
        {
          path: 'chatting',
          name: 'chatting',
          component: () => import('@/components/personal/menu/goodsOrder/chatting'),
        },//服务单位看的订单列表
        {
          path: 'servicechat',
          name: 'servicechat',
          component: () => import('@/components/personal/menu/goodsOrder/servicechat'),
        },//服务单位看的订单列表

        //政务服务模块
        {
          path: 'helpCompany',
          name: 'helpCompany',
          component: () => import('@/components/personal/menu/zhengfu/helpCompany'),
        },//帮扶动态
        {
          path: 'searchProblem',
          name: 'searchProblem',
          component: () => import('@/components/personal/menu/zhengfu/searchProblem'),
        },//帮扶搜集
        {
          path: 'approvalList',
          name: 'approvalList',
          component: () => import('@/components/personal/menu/zhengfu/approvalList'),
        },//在线审批发布
        {
          path: 'approvalOrderList',
          name: 'approvalOrderList',
          component: () => import('@/components/personal/menu/zhengfu/approvalOrderList'),
        },//在线审批处理
        {
          path: 'experience',
          name: 'experience',
          component: () => import('@/components/personal/menu/zhengfu/experience'),
        },//经验推荐处理
        {
          path: 'foursend',
          name: 'foursend',
          component: () => import('@/components/personal/menu/zhengfu/fourSend'),
        },//四送一服信息管理
        {
          path: 'experiencePublish',
          name: 'experiencePublish',
          component: () => import('@/components/personal/menu/zhengfu/experiencePublish'),
        },//经验推荐发布
        {
          path: 'newspolicyPublish',
          name: 'newspolicyPublish',
          component: () => import('@/components/personal/menu/zhengfu/newspolicyPublish'),
        },//政策前瞻发布
        {
          path: 'noticePublish',
          name: 'noticePublish',
          component: () => import('@/components/personal/menu/zhengfu/notice'),
        },//通知公告
        {
          path: 'noticeReport',
          name: 'noticeReport',
          component: () => import('@/components/personal/menu/zhengfu/noticeReport'),
        },//通知公告（上传材料）
        {
          path: 'sendPeopleList',
          name: 'sendPeopleList',
          component: () => import('@/components/personal/menu/zhengfu/sendPeopleList'),
        },//通知公告（可见人列表）

        //数据管理
        {
          path: 'companyStyleAudit',
          name: 'companyStyleAudit',
          component: () => import('@/components/personal/menu/shuju/companyStyleAudit'),
        },//云服务单位信息审核
        {
          path: 'companyStyleAuditCom',
          name: 'companyStyleAuditCom',
          component: () => import('@/components/personal/menu/shuju/companyStyleAuditCom'),
        },//企业风采信息审核
        {
          path: 'serviceUserPage',
          name: 'serviceUserPage',
          component: () => import('@/components/personal/menu/shuju/serviceUserPage'),
        },//云服务单位用户管理
        {
          path: 'goodsOrderList',
          name: 'goodsOrderList',
          component: () => import('@/components/personal/menu/shuju/goodsOrder'),
        },//云服务单位用户管理

        //政策信息
        {
          path: 'microVisionSpace',
          name: 'microVisionSpace',
          component: () => import('@/components/personal/menu/zhengcexinxi/microVisionSpace'),
        },//微视空间
        {
          path: 'analysis',
          name: 'analysis',
          component: () => import('@/components/personal/menu/zhengcexinxi/analysis'),
        },//深度分析
        {
          path: 'foursendList',
          name: 'foursendList',
          component: () => import('@/components/personal/menu/zhengcexinxi/foursend'),
        },//四送一服
        {
          path: 'foursendList1',
          name: 'foursendList1',
          component: () => import('@/components/personal/menu/zhengcexinxi/foursend1'),
        },//四送一服
        //数据统计
        {
          path: 'CompanyList',
          name: 'CompanyList',
          component: () => import('@/components/mineCenter/crm_claim/CompanyList'),
        },//企业明细列表
        {
          path: 'companyPosition',
          name: 'companyPosition',
          component: () => import('@/components/mineCenter/crm_claim/companyPosition')
        },
        {
          path: 'xinwenZX',
          name: 'xinwenZX',
          component: () => import('@/components/personal/menu/XinWenZX/news')
        },
        {
          path: 'newsGrabdata',
          name: 'newsGrabdata',
          component: () => import('@/components/personal/menu/XinWenZX/newsGrabdata')
        },
        {
          path: 'policypage',
          name: 'policypage',
          component: () => import('@/components/personal/menu/ZhengCeWjGl/policy.vue')
        },
        {
          path: 'policyGrabdata',
          name: 'policyGrabdata',
          component: () => import('@/components/personal/menu/ZhengCeWjGl/policyGrabdata.vue')
        },//smallbusiness
        {
          path: 'smallbusiness',
          name: 'smallbusiness',
          component: () => import('@/components/mineCenter/crm_claim/smallbusiness.vue')
        },//经营情况统计
        {
          path: 'smallbusinessdetail',
          name: 'smallbusinessdetail',
          component: () => import('@/components/mineCenter/crm_claim/smallbusinessdetail.vue')
        },//经营情况列表明细 declare
        {
          path: 'declare',
          name: 'declare',
          component: () => import('@/components/mineCenter/crm_claim/declare.vue')
        },//经营情况列表明细 declare
        {
          path: 'declaredetail',
          name: 'declaredetail',
          component: () => import('@/components/mineCenter/crm_claim/declaredetail.vue')
        },//经营情况列表明细 declar
      ]
    },//个人中心
    {
      path: "/analysisList",
      name: "analysisList",
      component: () => import('@/components/index/newsPage/analysislist')
    },  //深度分析列表列表
    {
      path: "/analysisDetail",
      name: "analysisDetail",
      component: () => import('@/components/index/newsPage/analysisdetail')
    },  //深度分析详情
    {
      path: "/spaceList",
      name: "spaceList",
      component: () => import('@/components/index/newsPage/spacelist')
    },  //微视空间列表列表
    {
      path: "/spaceDetail",
      name: "spaceDetail",
      component: () => import('@/components/index/newsPage/spacedetail')
    },  //微视空间详情
    {
      path: "/registered",
      name: "registered",
      component: () => import('@/components/registered')
    },//注册页面
    {
      path: "/resultPassword",
      name: "resultPassword",
      component: () => import('@/components/resultPassword')
    },//修改密码
    {
      path: "/newslist",
      name: "newslist",
      component: () => import('@/components/index/news/newslist')
    },  //新闻列表
    {
      path: "/newslist/newsdetali",
      name: "newsdetali",
      component: () => import('@/components/index/news/newsdetali')
    }, //新闻详情
    {
      path: "/parkstyle/parkStyle",
      name: "parkStyle",
      component: () => import('@/components/index/parkstyle/parkStyle')
    },//园区风采列表
    {
      path: "/parkstyle/parkDetail",
      name: "parkDetail",
      component: () => import('@/components/index/parkstyle/parkDetail')
    },//园区风采详情
    // {
    //   path: "/fastdeclarelist",
    //   name: "fastdeclarelist",
    //   component:() => import('@/components/index/fastdeclare/fastdeclarelist')
    // },//快速申报列表
    // {
    //   path: "/fastdeclarelist/fastdeclaredetali",
    //   name: "fastdeclaredetali",
    //   component:() => import('@/components/index/fastdeclare/fastdeclaredetali')
    // }, //快速申报详情
    {
      path: "/supplyneedlist",
      name: "supplyneedlist",
      component: () => import('@/components/index/supplyneed/supplyneedlist')
    },//供应速递列表
    {
      path: "/supplyneedlist/supplyneeddetail",
      name: "supplyneeddetail",
      component: () => import('@/components/index/supplyneed/supplyneeddetail')
    }, //供应速递详情
    {
      path: "/industry",
      name: "industry",
      component: () => import('@/components/index/industry/industry')
    }, //产业基金
    {
      path: "/industry/industrydetali",
      name: "industrydetali",
      component: () => import('@/components/index/industry/industrydetali')
    },//产业基金 政策资金详情
    {
      path: "/order",
      name: "order",
      component: () => import('@/components/index/order/order')
    },//工单检测
    {
      path: "/openly/policyrsxi",
      name: "policyrsxi",
      component: () => import('@/components/index/openly/policyrsxi')
    }, //人事消息
    {
      path: "/Corporation/CorporationXycs",
      name: "CorporationXycs",
      component: () => import('@/components/index/Corporation/CorporationXycs.vue')
    }, //信用查询列表
    {
      path: "/gauge",
      name: "gauge",
      component: () => import('@/components/index/gauge/gauge')
    },//寻计问策页面
    {
      path: "/gauge/gaugedeail",
      name: "gaugedeail",
      component: () => import('@/components/index/gauge/gaugedetail')
    },//政策前瞻详情
    {
      path: "/chaoshiinttest",
      name: "chaoshiinttest",
      component: () => import('@/components/index/chaoshi/chaoshiinttest.vue')
    },//中国工商银行
    {
      path: "/wordsude",
      name: "wordsude",
      component: () => import('@/components/index/telhelp/wordsude')
    },//联系帮扶诉求详情
    {
      path: "/productdetail",
      name: "productdetail",
      component: () => import('@/components/index/product/productdetail')
    },//产品详情
    {
      path: '/man',
      name: 'man',
      component: () => import('@/components/index/Corporation/rencai')
    }, {
      path: '/SearchService',
      name: '/SearchService',
      component: () => import('@/components/index/SearchService/serchService')
    }, {
      path: '/servicedetail',
      name: '/servicedetail',
      component: () => import('@/components/index/SearchService/servicedetail')
    },
    {
      path: '/diqus',
      name: '/diqus',
      component: () => import('@/components/mineCenter/crm_claim/diqus'),
    },//地区的审核状态
    {
      path: '/cityshop',
      name: '/cityshop',
      component: () => import('@/components/index/Corporation/cityShop'),
    },//地区的审核状态

    {
      path: "/liancate",
      name: "liancate",
      component: () => import('@/components/index/supermarket/liancate'),
      redirect: '/liancate/jinchao',
      children: [
        {
          path: 'jinchao',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'jinchao',
          component: () => import('@/components/index/supermarket/jinchao')
        },
        {
          path: 'jian',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'jian',
          component: () => import('@/components/index/supermarket/jian')
        },
      ]
    },//联盟服务
  ]
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js